import { Plugin } from "@tiptap/pm/state";

// Chromium on Windows attaches a dragged <img> as a file, so the file handler would take a block moved
// inside the editor for a file dropped from outside, insert it again and stop the drop before ProseMirror.
const ignoreInternalDrags = (plugin: Plugin) => {
	const { handleDrop } = plugin.props;
	if (!handleDrop) return plugin;

	return new Plugin({
		...plugin.spec,
		props: {
			...plugin.spec.props,
			handleDrop: (view, event, slice, moved) =>
				!view.dragging && handleDrop.call(plugin, view, event, slice, moved),
		},
	});
};

export default ignoreInternalDrags;
